var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert p-2 rounded mb-3 py-2",class:{
    'bg-pink-1': _vm.error,
    'bg-secondary-41': _vm.warning,
  }},[_c('div',{staticClass:"d-flex align-items-center"},[_c('em',{staticClass:"font-16 pl-2 ml-1",class:{
        'fas fa-times-circle color-secondary-20': _vm.error,
        'fas fa-bell-exclamation color-secondary-40': _vm.warning,
      }}),_c('div',{staticClass:"font-14 font-weight-normal ml-3",class:{
        'color-secondary-20': _vm.error,
        'color-secondary-40': _vm.warning,
      }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }